import { ActionType } from 'typesafe-actions';
import * as feedAction from './feed';

export const FEED_ACTION_PREFIX = 'FEED';

export const feedActions = { ...feedAction };

export type FeedActions = ActionType<typeof feedAction>;
